import { formatRelanceDate } from "./relanceDates";

export const penaltyMoney = (amount, currency) =>
  amount == null ? "À vérifier" : `${Number(amount).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`;

const PenaliteBreakdown = ({ calcul, compact = false }) => {
  if (!calcul) return null;
  const total = Object.entries(calcul.totaux || {}).map(([currency, amount]) => penaltyMoney(amount, currency)).join(" + ");
  const content = <div className="space-y-2">
    {calcul.motif && <p className={calcul.etat === "taux_manquant" ? "text-red-700" : "text-gray-500"}>{calcul.motif}</p>}
    <dl className="grid grid-cols-[1fr_auto] gap-x-3 gap-y-1">
      <dt>Facture initiale</dt><dd className="text-right">{penaltyMoney(calcul.montant_facture, calcul.devise)}</dd>
      {calcul.principal !== calcul.montant_facture && <><dt>Principal retenu</dt><dd className="text-right">{penaltyMoney(calcul.principal, calcul.devise)}</dd></>}
      <dt>Pénalités de retard</dt><dd className="text-right">{penaltyMoney(calcul.interets, calcul.devise)}</dd>
      <dt>Indemnité de recouvrement</dt><dd className="text-right">{penaltyMoney(calcul.indemnite_eur, "EUR")}</dd>
      <dt className="font-semibold">Total à régler</dt><dd className="font-semibold text-right">{total || "À vérifier"}</dd>
    </dl>
    {calcul.reclamables && <p className="text-gray-500">
      Décompte au {formatRelanceDate(calcul.date_calcul)}, {calcul.jours_retard} jour(s) de retard.
      L'indemnité est comptée une seule fois pour cette facture.
      Le calcul suppose la facture intégralement impayée.
    </p>}
    {!!calcul.periodes?.length && <details>
      <summary className="cursor-pointer text-primary-700">Détail par semestre</summary>
      <div className="overflow-x-auto mt-2">
        <table className="w-full text-left">
          <thead><tr><th className="pr-3">Période</th><th className="pr-3">Jours</th><th className="pr-3">Taux annuel</th><th>Intérêts</th></tr></thead>
          <tbody>{calcul.periodes.map((period) => <tr key={period.semestre}>
            <td className="pr-3 py-1">{formatRelanceDate(period.debut)} au {formatRelanceDate(period.fin)}</td>
            <td className="pr-3">{period.jours}</td><td className="pr-3">{period.taux_annuel} %</td>
            <td>{penaltyMoney(period.interets, calcul.devise)}</td>
          </tr>)}</tbody>
        </table>
      </div>
      <p className="text-gray-500 mt-2">Intérêts simples sur 365 jours, arrondis au centime sur le total.</p>
    </details>}
  </div>;
  return compact ? <details className="text-xs text-gray-700">
    <summary className="cursor-pointer text-primary-700">Décompte du retard{calcul.reclamables ? ` : ${total}` : ""}</summary>
    <div className="mt-2">{content}</div>
  </details> : <section className="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-700 space-y-3">
    <h3 className="font-semibold text-gray-900">Décompte du retard</h3>{content}
  </section>;
};

export default PenaliteBreakdown;
